<template>
    <v-container grid-list-xs fluid>
        <v-toolbar dense dark color="secondary">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Reconciliation Parkland
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-row>
                <v-col cols="12">
                    <v-card elevation="10" outlined>
                        <v-card-title>
                            Reports
                        </v-card-title>
                        <v-card-actions>
                            <v-text-field
                                label="Start Date"
                                id="StartDate"
                                class="mr-2"
                                placeholder="YYYY-MM-DD"
                                v-mask="'####-##-##'"
                            ></v-text-field>
                            <v-text-field
                                label="End Date"
                                id="EndDate"
                                class="ml-2"
                                placeholder="YYYY-MM-DD"
                                v-mask="'####-##-##'"
                            ></v-text-field>
                        </v-card-actions>
                        <v-card-actions justify="center">
                            <v-btn color="secondary" @click="InvSummaryReport"
                                >Invoice Summary</v-btn
                            >
                            <v-btn color="secondary" @click="outStandingBols"
                                >Outstanding Bol's</v-btn
                            >
                            <v-btn color="secondary" @click="openClearingDocs"
                                >Statement Uploaded By Clearing Doc</v-btn
                            >
                            <v-btn color="secondary" @click="openStmtRange"
                                >Statement Summary <br />
                                by Date Range</v-btn
                            >
                            <v-btn
                                color="secondary"
                                @click="openStmtRangeInvoice"
                                >Invoice Summary <br />
                                by Date Range</v-btn
                            >
                            <!-- <v-btn color="secondary">Statement Summary By Date Range</v-btn>
                            <v-btn color="secondary">Invoice Summary By Date Range</v-btn> -->
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-card elevation="10" outlined>
                        <v-card-title>
                            Upload a new file
                        </v-card-title>
                        <v-card-actions grid-list-xs>
                            <input
                                type="file"
                                class="mr-12"
                                @change="readExcel"
                            />

                            <v-btn
                                color="primary"
                                class="mr-12"
                                small
                                @click="sendExcel()"
                                ><v-icon>mdi-upload</v-icon> Upload File</v-btn
                            >

                            <v-btn
                                color="teal"
                                dark
                                class="ml-12"
                                small
                                @click="sendSaveExcel()"
                                ><v-icon>mdi-content-save</v-icon> Save
                                File</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <v-card elevation="10" outlined>
                        <v-card-title>
                            Reconciliation By
                        </v-card-title>
                        <v-card-actions grid-list-xs>
                            <v-combobox
                                v-model="Invoice"
                                :items="Invoices"
                                label="Invoice ID"
                                :item-text="'Text'"
                                :item-value="'InvId'"
                                dense
                                hide-details
                                auto-select-first
                                class="mx-6"
                            ></v-combobox>
                            <v-btn
                                dark
                                color="teal"
                                large
                                @click="openMatchByInvoice"
                                >Matched Bols Unmatched <br />
                                Amounts By Invoice</v-btn
                            >
                            <v-combobox
                                v-model="File"
                                :items="Files"
                                label="File Payments"
                                :item-text="'FileName'"
                                :item-value="'CheckNumber'"
                                dense
                                hide-details
                                auto-select-first
                                class="mx-6"
                            ></v-combobox>
                            <v-btn
                                color="secondary"
                                large
                                @click="openStmtSummarybyStmts(0)"
                                >Statement Summary <br />
                                Report by Statement</v-btn
                            >
                            <v-btn
                                color="secondary"
                                large
                                @click="openStmtSummarybyStmts(1)"
                                >Statement Summary <br />
                                Report by Statement Detail</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-container grid-list-xs fluid>
                    <v-card elevation="10" outlined>
                        <v-data-table :headers="headers" :items="xlsx" dense>
                        </v-data-table>
                    </v-card>
                </v-container>
            </v-row>
        </v-container>
        <match v-if="$store.state.Parkland.Match" :parms="parms"></match>
        <stmt_details
            v-if="$store.state.Parkland.Stmt"
            :parms="parms"
            :title="title"
        ></stmt_details>
        <stmt_range_invoice
            v-if="$store.state.Parkland.StmtRangeInvoice"
            :parms="parms"
        ></stmt_range_invoice>
        <stmt_range
            v-if="$store.state.Parkland.StmtRange"
            :parms="parms"
        ></stmt_range>
        <clear v-if="$store.state.Parkland.Ucd" :parms="parms"></clear>
        <inv_sum v-if="$store.state.Parkland.InvSum" :parms="parms"></inv_sum>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import * as XLSX from 'xlsx/xlsx.js';
import match from './../Modals/Conciliation/ParkLand/MatchBOLByInvoice.vue';
import stmt_details from './../Modals/Conciliation/ParkLand/StmtSummaryByStmt.vue';
import inv_sum from './../Modals/Conciliation/ParkLand/InvoiceSummary.vue';
import clear from './../Modals/Conciliation/ParkLand/UploadedByClearingDoc.vue';
import stmt_range from './../Modals/Conciliation/ParkLand/PaymentByRange.vue';
import stmt_range_invoice from './../Modals/Conciliation/ParkLand/PaymentByRangeInvoice.vue';
export default {
    directives: { mask },
    components: {
        match,
        stmt_details,
        inv_sum,
        clear,
        stmt_range,
        stmt_range_invoice
    },
    data: function() {
        return {
            parms: null,
            valid: false,
            customers: [],
            customer: [],
            excel: null,
            data: [],
            stations: [],
            terminals: [],
            rates: [],
            CustomerRate: [],
            ranges: [],
            Files: [],
            File: null,
            Invoices: [],
            Invoice: null,
            range: [],
            jsonData: null,
            invoices: [],
            invoice: [],
            title: null,
            headers: [
                { text: 'Payment ID', value: 'PaymentID' },
                { text: 'Internal Voucher', value: 'InternalVoucher' },
                { text: 'BOL', value: 'BOL.' },
                { text: 'LoadDate', value: 'LoadDate' },
                { text: 'MaterialGroup', value: 'MaterialGroup' },
                { text: 'Origin', value: 'Origin' },
                { text: 'OriginName', value: 'OriginName' },
                { text: 'Destination', value: 'Destination' },
                { text: 'DestinationName', value: 'DestinationName' },
                { text: 'City', value: 'City' },
                { text: 'NetQuantity', value: 'NetQuantity' },
                { text: 'TransactionUoM', value: 'TransactionUoM' },
                { text: 'BaseRate', value: 'BaseRate' },
                { text: 'FuelSurcharge', value: 'FuelSurcharge%' },
                { text: 'TotalRate', value: 'TotalRate' },
                { text: 'NetAmountBaseFS', value: 'NetAmount(Base+FS)' },
                { text: 'TotalAmountwithTax', value: 'TotalAmountwithTax' },
                { text: 'TotalTaxAmount', value: 'TotalTaxAmount' },
                { text: 'HSTAmount', value: 'HSTAmount' },
                { text: 'TaxRateArea', value: 'TaxRateArea' },
                { text: 'Description', value: 'Description' },
                { text: 'DateCreated', value: 'DateCreated' },
                { text: 'FileName', value: 'FileName' },
                { text: 'regPmtUser', value: 'regPmtUser' },
                { text: 'regPmtDttm', value: 'regPmtDttm' }
            ],
            xlsx: []
        };
    },
    //
    mounted() {
        this.getNamesFiles();
        this.getInvoices();
    },
    methods: {
        InvSummaryReport: function() {
            this.$store.state.Parkland.InvSum = true;
            this.parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
        },
        openStmtSummarybyStmts: function(type) {
            this.$store.state.Parkland.Stmt = true;
            this.parms = {
                CheckNumber: this.File.CheckNumber,
                Type: type,
                FileName: this.File.FileName
            };
            if (type == 1) {
                this.title = 'Stament Summary Report By Statement Details';
            } else {
                this.title = 'Stament Summary Report By Statement';
            }
        },
        openStmtRange: function() {
            this.$store.state.Parkland.StmtRange = true;
            this.parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
        },
        openStmtRangeInvoice: function() {
            this.$store.state.Parkland.StmtRangeInvoice = true;
            this.parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
        },
        openClearingDocs: function() {
            this.$store.state.Parkland.Ucd = true;
            this.parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
        },
        openMatchByInvoice: function() {
            this.$store.state.Parkland.Match = true;
            this.parms = {
                InvId: this.Invoice.InvId,
                Type: false
            };
        },
        outStandingBols: function() {
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Export: true
            };
            axios
                .post('conciliation/parkland/out-standing-bols', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Out-Standing-Bols.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        readExcel: async function(e) {
            // console.log(e.target.files[0]);
            this.name = e.target.files[0].name;
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = async e => {
                const data = new Uint8Array(e.target.result);
                const workbook = await XLSX.read(data, { type: 'array' });
                console.log(workbook);
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = await XLSX.utils.sheet_to_json(worksheet);
                this.jsonData = JSON.stringify(jsonData, null, 2);
                console.log(this.jsonData);
            };
            console.log(reader);
            reader.readAsArrayBuffer(file);
        },
        sendExcel: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Data: this.jsonData,
                FileName: this.name
            };
            this.entries = null;
            axios
                .post('conciliation/parkland/preparing-data', parms)
                .then(async response => {
                    this.xlsx = response.data;
                    this.xlsx.forEach(function(objeto) {
                        objeto['TaxRateArea'] = objeto['TaxRate/Area'];
                        delete objeto['TaxRate/Area'];

                        objeto['FuelSurchargePercent'] =
                            objeto['FuelSurcharge%'];
                        delete objeto['FuelSurcharge%'];

                        objeto['NetAmountBaseFS'] =
                            objeto['NetAmount(Base+FS)'];
                        delete objeto['NetAmount(Base+FS)'];

                        delete objeto['FromPaymentDate'];
                    });
                    console.log(this.xlsx);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        sendSaveExcel: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Data: this.xlsx,
                FileName: this.name
            };
            this.entries = null;
            axios
                .post('conciliation/parkland/save-data', parms)
                .then(async response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getNamesFiles: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('conciliation/parkland/files-names')
                .then(async response => {
                    this.Files = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getInvoices: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('conciliation/parkland/invoices')
                .then(async response => {
                    this.Invoices = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
<style>
.shrink {
    max-width: 200px;
    /* Ajusta según tu necesidad */
    white-space: nowrap;
    /* Evita que el texto se rompa en varias líneas */
    overflow: hidden;
    text-overflow: ellipsis;
    /* Añade puntos suspensivos si el texto es demasiado largo */
}</style
>./Parkland.vue../Modals/Conciliation/ParkLand/PaymentByRangeInvoice.vue
